module.exports = __webpack_public_path__ + "img/new_spotd7.bf095e0b.gif";